<template>
  <div>
    <h3 class="student-subaccount-box--title mb-3">
      {{ $t("bookedWebinars") }}
    </h3>

    <v-row class="mb-4">
      <v-col cols="6" lg="3">
        <v-menu v-model="showFromPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.from_date_time" v-bind:label="$t('fromDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('from_date_time')" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getClasses" color="green lighten-1" v-model="date.from_date_time"
            @input="showFromPicker = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="6" lg="3">
        <v-menu v-model="showToPicker" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition" offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.to_date_time" v-bind:label="$t('toDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('to_date_time')" :disabled="!date.from_date_time" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getClasses" color="green lighten-1" v-model="date.to_date_time"
            @input="showToPicker = false" :allowed-dates="checkAllowedDates"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headersTitles"
      :items="upcomingWebinars"
      item-key="id"
      class="elevation-1"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
    >
      <template v-slot:body="{ items }">
        <tbody v-if="upcomingWebinars.length">
          <tr v-for="item in items" :key="item.id">
            <td class="text-xs-right">{{ item.webinar_type }}</td>
            <td class="text-xs-right">{{ item.start_date }}</td>
            <td class="text-xs-right">{{ item.start_time }}</td>
            <td class="text-xs-right">{{ item.title }}</td>
            <td class="text-xs-right">
              {{ item.tutor ? `${item.tutor.full_name}` : "NA" }}
            </td>
            <td class="action-column">
              <button
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="btn-round add-student-btn"
                type="button"
                @click="startZoomMeeting(item.zoom_meeting.zoom_meeting_number)"
              >
                Join Class
              </button>

              <button
                v-else
                disabled
                class="btn-round add-student-btn disabled-btn"
                type="button"
                @click="startZoomMeeting(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClass") }}
              </button>

              <button
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="btn-round add-student-btn"
                type="button"
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClassZoomStudent") }}
              </button>

              <button
                v-else
                disabled
                class="btn-round add-student-btn disabled-btn"
                type="button"
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("joinClassZoomStudent") }}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="headersTitles.length" style="text-align: center">
              {{ $t("noResultsHere") }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import GlobalMixin from "@/GlobalMixin.js";
export default {
  name: "BookedWebinars",
  mixins: [GlobalMixin],
  data() {
    return {
      todayDate: "",
      timeNow: "",
      dataBody: {},
      upcomingWebinars: [],
      inMeeting: false,

      showFromPicker: false,
      showToPicker: false,
      date: {},
    };
  },
  mounted() {
    this.inMeeting = window.localStorage.getItem("inMeeting");
    window.addEventListener("storage", () => {
      this.inMeeting = window.localStorage.getItem("inMeeting");
    });
  },
  async created() {
    var date = new Date();
    var options = { hour12: false };
    var CurrentTime = date.toLocaleString("en-US", options);
    var time = CurrentTime.split(",")[1].split(":")[0];

    this.todayDate = moment().format("Y-MM-DD");

    if (time == 24) {
      this.timeNow = time - 24;
    } else {
      this.timeNow = CurrentTime.split(",")[1].trim();
    }

    await this.getClasses();
  },
  methods: {
    async getClasses() {
      const {from_date_time, to_date_time} = this.date;
      const body = {
        ...this.dataBody,
      }
      if (from_date_time) body.from_date_time = `${from_date_time} 00:00:00`;
      if (to_date_time) body.to_date_time = `${to_date_time} 00:00:00`;
      let upcomingsUrl = process.env.VUE_APP_APIEndPoint + "reserve/upcomings/";
      let response = await this.axios.post(
        upcomingsUrl,
        body,
        this.headers
      );
      if (response) {
        this.upcomingWebinars = response.data.data.upcoming_webinar;
      } else {
        console.log("error while getting tutor current classes....");
      }
    },
    async startZoomMeeting(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      this.$router.push({ name: "meeting", query: { uid: uid, mid: mid } });
    },

    joinOnZoom(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      let data = {
        uid,
        mid,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/meeting/`,
          data,
          this.headers
        )
        .then((response) => {
          if (response) {
            window.open(response.data.data.zoom_meeting.join_meeting_url);
          }
        });
    },
    isSessionTime(item) {
      let startTimestamp = moment(`${item.start_date} ${item.start_time}`)
        // .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let endTimestamp = moment(`${item.end_date} ${item.end_time}`)
        // .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let currentTimestamp = moment(
        `${moment()
          // .tz(this.headers.headers["USER-TIMEZONE"])
          .format("D/M/Y HH:mm:ss")}`,
        "D/M/Y HH:mm:ss"
      ).unix();
      return (
        currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp
      );
    },
    checkAllowedDates(date) {
      return date >= this.date.from_date_time;
    },
    clearFilter(type) {
      delete this.date[type];
      this.getClasses();
    },
  },
  computed: {
    headersTitles() {
      return [
        { text: this.$t("course_Type"), value: "CourseType", sortable: false },
        { text: this.$t("Start_Date"), value: "startDate", sortable: false },
        { text: this.$t("Start_Time"), value: "startTime", sortable: false },
        {
          text: this.$t("programName"),
          value: "programeName",
          sortable: false,
        },
        { text: this.$t("tutorName"), value: "tutortName", sortable: false },
        { text: this.$t("Action"), value: "action", sortable: false },
      ];
    },
  },
};
</script>
<style scoped lang="scss">
.btn-round {
  padding: 4px 10px;
}

.disabled-btn,
.disabled-btn:hover {
  background-color: #c0c5be;
}

.action-column {
  display: flex;
  gap: 5px;
}
</style>
